export const SCREEN_WIDTH_DESKTOP = 1280;
export const MAP_CONTROL_LEFT_DESKTOP = "1.5rem";
export const MAP_CONTROL_LEFT_TABLET = "24.5rem";
